import { apiClient } from '../ruutsApi/client'
import endpoints from '../ruutsApi/endpoints'
import { unwrapSingle } from '../ruutsApi/normalize'

type MonitoringSocExport = {
  monitoringSocSites: unknown[]
  monitoringSites: Record<string, unknown>[]
}

// The endpoint 400s without farmId.
export const getMonitoringSoc = async ({
  farmId,
}: {
  farmId: string
}): Promise<MonitoringSocExport> => {
  const response = await apiClient.get(endpoints.monitoringExportForSoc, { params: { farmId } })
  return unwrapSingle<MonitoringSocExport>(response)
}
